import { render } from "./AddressForm.vue?vue&type=template&id=05ae4641&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=ts"
export * from "./AddressForm.vue?vue&type=script&lang=ts"

import "./AddressForm.vue?vue&type=style&index=0&id=05ae4641&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-05ae4641"

export default script